import React from 'react';

import { IconProps } from '../../../icons/Icon.types';
import { Container } from '../Button.styles';
import { IconButtonProps } from './IconButton.types';

export function IconButton({
  icon,
  variant = 'contained',
  size = 'lg',
  iconColor,
  iconSize,
  ...props
}: IconButtonProps) {
  const Icon = icon as React.FunctionComponent<React.SVGProps<SVGSVGElement> & IconProps>;
  return (
    <Container variant={variant} size={size} typeButton="iconButton" {...props}>
      <Icon color={iconColor} size={iconSize} />
    </Container>
  );
}
